import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {ACCESS_TOKEN, DEFAULT_RETURN_URL_EXTERNAL_USER, RETURN_URL} from '../consts';
import {tokenNotExpired} from '../utilities/token-not-expired';
import * as _ from 'lodash';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../reducers';
import * as fromClient from '../../client/reducers';
import {Observable} from 'rxjs';
import {Role} from '../models/role';
import {map, take } from 'rxjs/operators';

@Injectable()
export class InternalUserGuard implements CanActivate {
  roles$: Observable<Role[]>;
  constructor(private router: Router ,
              private store: Store<fromClient.AppState>) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // @ts-ignore
    return this.store.select(fromShared.selectors.getMyRoles).pipe(
      take(1), // Ensures subscription completes after first value
      map(roles => {
        if (roles && roles.length > 0) {
          const isInternalUser = _.some(roles, { code: 'BO_INTERNAL_USER' });

          if (isInternalUser) {
            localStorage.setItem('BO_INTERNAL_USER', 'true');
            return true;
          } else {
            localStorage.setItem('BO_INTERNAL_USER', 'false');
            this.router.navigate(['/', ...DEFAULT_RETURN_URL_EXTERNAL_USER]); // Correct navigation
            return false;
          }
        }
        this.router.navigate(['/login']); // Handle case when no roles exist
        return false;
      })
    );
  }
}
